module.exports = __webpack_public_path__ + "a3a30591c25bca3297b9d54f1ab10dba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-8.png
// module id = 1687
// module chunks = 0